import { useQuery } from 'react-query';
import { ClientsAPI } from '.';

type ParamsSeller = {
  entityId: string;
  documentNumber: string;
  documentType: string;
  business: string;
};

export function useGetBlackListDomain() {
  return { blackList: undefined };
}

export function useGetValidateSeller(paramsSeller: ParamsSeller) {
  return useQuery(
    ['validate_seller', paramsSeller],
    (key, params: any) => ClientsAPI.getValidateSeller({ params }),
    {
      cacheTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
}
